import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

export const Underline = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Underline({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        d='M10.0036 14.4167C9.40358 14.4167 8.84247 14.3278 8.32025 14.1501C7.80914 13.9612 7.35914 13.689 6.97025 13.3334C6.59247 12.9667 6.29247 12.5167 6.07025 11.9834C5.85914 11.4501 5.75358 10.8334 5.75358 10.1334V3.75001C5.75358 3.51989 5.94013 3.33334 6.17025 3.33334H6.95358C7.1837 3.33334 7.37025 3.51989 7.37025 3.75001V10.0834C7.37025 10.9834 7.59803 11.6778 8.05358 12.1667C8.52025 12.6556 9.17025 12.9001 10.0036 12.9001C10.8369 12.9001 11.4814 12.6556 11.9369 12.1667C12.3925 11.6778 12.6202 10.9834 12.6202 10.0834V3.75001C12.6202 3.51989 12.8068 3.33334 13.0369 3.33334H13.8369C14.067 3.33334 14.2536 3.51989 14.2536 3.75001V10.1334C14.2536 10.8334 14.1425 11.4501 13.9202 11.9834C13.7091 12.5167 13.4091 12.9667 13.0202 13.3334C12.6425 13.689 12.1925 13.9612 11.6702 14.1501C11.1591 14.3278 10.6036 14.4167 10.0036 14.4167Z'
        fill={color}
      />
      <path
        d='M5 15.4167C5 15.1866 5.18655 15 5.41667 15H14.5833C14.8135 15 15 15.1866 15 15.4167V16C15 16.2301 14.8135 16.4167 14.5833 16.4167H5.41667C5.18655 16.4167 5 16.2301 5 16V15.4167Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent viewBox='0 0 20 20' ref={ref} dataTestId={dataTestId ?? 'underline-icon-svg'} iconRender={iconRender} {...props} />;
});
